import {
    computed, nextTick,
} from "vue";
import urls from "../urls";
import cookies from "../cookies";
import ApiRequest from "../api-request";

import demoFormToggler from "../components/demo-form/demo-form-toggler";
import demoForm from "../components/demo-form/index";
import cleanUploader from "../clean/uploader/clean-uploader";
import addressResults from "../suggestions/nx-demo/results/address";

import validators from "../clean/validators";

import createComponent from "../vue";

import { inferQcComplete } from "../domain/address";
import {
    QC_COMPLETE_MESSAGES,
    QC_MESSAGES,
    optionsData,
} from "../clean/nx-demo/data";

const BASE_URL = urls.api.demoClean.getUrl();
const API_TOKEN = window.DA.settings.API_KEY;
const CSRF_TOKEN = cookies.get("csrftoken");

createComponent({
    data() {
        return {
            togglerValue: "",
            togglerOptions: [
                {
                    id: "file",
                    text: "В файле",
                }, {
                    id: "form",
                    text: "По одной записи",
                },
            ],
            loading: false,
            value: "",
            showResults: false,
            results: {},
            error: null,
            url: `${BASE_URL}/address`,
            showPostDate: true,
            validator: validators.getTextErrors,
        };
    },
    computed: {
        // сообщения о качестве и пригодности к рассылке
        // берутся из дефолтных данных или высчитываются по справочникам из data
        messages() {
            if (!Object.keys(this.results).length) return null;

            const qcComplete = inferQcComplete(this.results);

            const qcMessage = QC_MESSAGES.address[this.results.qc] || QC_MESSAGES.address.default;
            const qcCompleteMessage = QC_COMPLETE_MESSAGES[qcComplete] ||
                                        QC_COMPLETE_MESSAGES.default;

            return {
                qcMessage,
                qcCompleteMessage,
            };
        },
        resultIsEmpty() {
            return Boolean(!this.results?.result);
        },
        isDefaultValue() {
            return this.value.trim() === this.adressInputData.defaultValue;
        },
        adressInputData() {
            return optionsData.find(option => option.id === "address");
        },
    },
    methods: {
        clear() {
            this.results = {};
            this.showResults = false;
            this.loading = false;
            this.indexError = false;
            this.showPostDate = true;
            this.error = null;
        },
        // по готовности компонента с результатами останавливает загрузку
        handleChildReady() {
            this.loading = false;
        },
        async handleSubmit() {
            this.clear();
            this.loading = true;

            // если в инпуте дефолтное значение, то делать запрос к API не нужно
            // используются дефолтные данные для вывода результатов
            if (this.isDefaultValue && this.adressInputData.result) {
                this.results = this.adressInputData.result;
                this.showResults = true;
                this.loading = false;
                return;
            }

            await this.fetchData();

            nextTick(() => {
                if (!this.results.postal_code) {
                    this.indexError = true;
                    this.showPostDate = false;
                    this.results.postal_code = (this.results.house || this.results.stead)
                        ? "Не знаем индекса для указанного адреса"
                        : "Определим индекс только для адреса с номером дома";
                }
            });
        },
        async fetchData() {
            // запрос данных через API стандартизации
            try {
                const api = new ApiRequest(this.url, {
                    token: API_TOKEN,
                    csrf: CSRF_TOKEN,
                });
                const res = await api.send([this.value]);
                this.results = res[0];
                this.showResults = true;
                if (this.resultIsEmpty) {
                    this.loading = false;
                }
            } catch (e) {
                console.error(e);
                this.clear();
                this.error = "Ошибка связи с сервером";
            }
        },
    },
    created() {
        this.value = this.adressInputData.defaultValue;
    },
    mounted() {
        this.postDate = this.$el.parentNode.dataset.post || "";
        this.togglerValue = "file";
    },
    watch: {
        togglerValue() {
            this.clear();
        },
    },
    // провайдит postDate для компонента с результатами по адресу
    provide() {
        return { postDate: computed(() => this.postDate) };
    },
    components: {
        cleanUploader,
        demoFormToggler,
        demoForm,
        addressResults,
    },
}, "#js-index-demo");
